import { TodoItemWrapper } from '@state/util/todoList'

import type { FacingProducerOptions } from '@components/shelfDetails/ShelfDetails'

export function taskItemFacingProducer({ facing, task }: FacingProducerOptions & {task: TodoItemWrapper}): string {
  if (task.product.gtin !== facing.gtin) {
    return ''
  }

  switch (task.action) {
    case 'CHECK': return 'bg-todo-action-check'
    case 'REFILL': return 'bg-todo-action-refill'
    case 'REORDER': return 'bg-todo-action-reorder'
  }

  return ''
}